import * as React from "react"
const SvgCrop = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17 22.143v-3H7q-.824 0-1.412-.588A1.93 1.93 0 0 1 5 17.143v-10H2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 6.143q0-.425.288-.713A.97.97 0 0 1 2 5.143h3v-3q0-.424.287-.713A.97.97 0 0 1 6 1.143q.424 0 .713.287.287.288.287.713v15h15a.97.97 0 0 1 .712.287q.288.288.288.713c0 .425-.096.52-.288.712a.97.97 0 0 1-.712.288h-3v3q0 .424-.288.712a.97.97 0 0 1-.712.288.97.97 0 0 1-.712-.288.97.97 0 0 1-.288-.712m0-7v-8H9v-2h8q.824 0 1.413.587.587.588.587 1.413v8z" />
  </svg>
)
export default SvgCrop
